<section class="space-y-4">
  <h1 class="text-2xl font-bold">Page not found</h1>
  <p>The requested page does not exist.</p>
  <a href="#/" class="btn btn-primary">Return to overview</a>
</section>
